import { render, staticRenderFns } from "./NumberTwoSVG.vue?vue&type=template&id=66295384&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66295384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66295384')) {
      api.createRecord('66295384', component.options)
    } else {
      api.reload('66295384', component.options)
    }
    module.hot.accept("./NumberTwoSVG.vue?vue&type=template&id=66295384&scoped=true&", function () {
      api.rerender('66295384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/NumberTwoSVG.vue"
export default component.exports